import { useMemo } from 'react';
import { useResponsive } from '@sg/garnish';

import { Navbar } from '../../../../../components';
import {
  CONTENT_WITH_BG_COLOR_STYLES,
  SCREEN_HEADER_OPTIONS,
  type ScreenOptions,
  type ScreenOptionsMap,
} from '../../../../constants';
import { useRouteTitles } from '../../../messages';

// ─────────────────────────────────────────────────────────────────────────────

export const useAuthStackOptions = () => {
  const { match } = useResponsive();

  const titles = useRouteTitles();

  // ─────────────────────────────────────────────────────────────────────

  const stackOptions = useMemo(() => {
    return {
      ...SCREEN_HEADER_OPTIONS,
      headerShown: true,
      header: match([undefined, () => <Navbar />]),
      presentation: match(['modal', 'transparentModal']),
      contentStyle: CONTENT_WITH_BG_COLOR_STYLES,
    } satisfies ScreenOptions;
  }, [match]);

  // ─────────────────────────────────────────────────────────────────────

  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: stackOptions,

      // ─── Individual Screen Options ───────────────────────────────────────

      JoinOrSignIn: {
        customDocumentTitle: titles.joinOrSignInCustomDocumentTitle,
      },
    } satisfies ScreenOptionsMap;
  }, [stackOptions, titles]);
};
